import { bidPaymentStatuses, bidPaymentStatusesEnum } from "helpers/enums";
import { requiredField } from "helpers/validators";
import moment from "moment";
import React from "react";

const paymentConfig = {
    invoiceDate: {
        label: "Дата выставления счёта",
        inputProps: { name: "invoiceDate", type: "date" },
    },
    planPaymentDate: {
        label: "Плановая дата оплаты",
        inputProps: { name: "planPaymentDate", type: "date" },
    },
    factPaymentDate: {
        label: "Фактическая дата оплаты",
        inputProps: { name: "factPaymentDate", type: "date" },
    },
    paymentStatus: {
        label: "Статус оплаты",
        inputProps: { name: "paymentStatus" },
        options: bidPaymentStatuses,
    },
    remainingPayment: {
        label: "Остаток к оплате",
        inputProps: { name: "remainingPayment", type: "number", step: "0.01" },
    },
    comment: {
        label: "Комментарий",
        inputProps: { name: "comment" },
    },
};

export const payableStatuses = bidPaymentStatuses.map((status) => ({
    ...status,
    label: {
        [bidPaymentStatusesEnum.NotPaid]: "Не выплачено",
        [bidPaymentStatusesEnum.Paid]: "Выплачено",
        [bidPaymentStatusesEnum.PartiallyPaid]: "Частично выплачено",
    }[status.value],
}));

export const paymentFieldsConfig = (isAccountsPayable = false) => ({
    ...paymentConfig,
    invoiceDate: {
        ...paymentConfig.invoiceDate,
        label: isAccountsPayable ? "Дата получения счёта" : paymentConfig.invoiceDate.label,
    },
    planPaymentDate: {
        ...paymentConfig.planPaymentDate,
        label: isAccountsPayable ? "Плановая дата выплаты" : paymentConfig.planPaymentDate.label,
    },
    factPaymentDate: {
        ...paymentConfig.factPaymentDate,
        label: isAccountsPayable ? "Фактическая дата выплаты" : paymentConfig.factPaymentDate.label,
    },
    paymentStatus: {
        ...paymentConfig.paymentStatus,
        label: isAccountsPayable ? "Статус выплаты" : paymentConfig.paymentStatus.label,
        options: isAccountsPayable ? payableStatuses : bidPaymentStatuses,
    },
    remainingPayment: {
        ...paymentConfig.remainingPayment,
        label: isAccountsPayable ? "Остаток к выплате" : paymentConfig.remainingPayment.label,
    },
});

const requiredFieldValidators = [requiredField];

const PaymentFields = ({
    payment: initialPayment,
    isAccountsPayable = false,
    onChange,
    renderDateField,
    renderField,
    renderSelect,
}) => {
    const payment = initialPayment || {};
    const config = paymentFieldsConfig(isAccountsPayable);
    const paymentStatus = payment.paymentStatus || bidPaymentStatusesEnum.NotPaid;
    const setPaymentValue = ({ name, value }) => {
        if (["invoiceDate", "planPaymentDate", "factPaymentDate"].includes(name)) {
            value = value ? moment(value).format("YYYY-MM-DD") : null;
        }
        const newValue = { [name]: value };
        if (name === "paymentStatus") {
            if (value !== bidPaymentStatusesEnum.PartiallyPaid) {
                newValue.remainingPayment = null;
            }
            if (value !== bidPaymentStatusesEnum.Paid) {
                newValue.factPaymentDate = null;
            }
        }
        onChange({ paymentStatus, ...payment, ...newValue });
    };
    const commonProps = {
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    };

    return (
        <>
            {renderDateField({
                ...config.invoiceDate,
                ...commonProps,
                onChange: setPaymentValue,
                value: payment.invoiceDate,
            })}
            {renderDateField({
                ...config.planPaymentDate,
                ...commonProps,
                required: paymentStatus !== bidPaymentStatusesEnum.NotPaid,
                validators: paymentStatus !== bidPaymentStatusesEnum.NotPaid ? requiredFieldValidators : [],
                onChange: setPaymentValue,
                value: payment.planPaymentDate,
            })}
            {renderSelect({
                ...config.paymentStatus,
                ...commonProps,
                onChange: setPaymentValue,
                value: paymentStatus,
                unClearable: true,
            })}
            {paymentStatus === bidPaymentStatusesEnum.Paid &&
                renderDateField({
                    ...config.factPaymentDate,
                    ...commonProps,
                    required: true,
                    validators: requiredFieldValidators,
                    onChange: setPaymentValue,
                    value: payment.factPaymentDate,
                })}
            {paymentStatus === bidPaymentStatusesEnum.PartiallyPaid &&
                renderField({
                    ...config.remainingPayment,
                    ...commonProps,
                    required: true,
                    validators: requiredFieldValidators,
                    onChange: setPaymentValue,
                    value: payment.remainingPayment,
                })}
            {renderField({
                ...config.comment,
                ...commonProps,
                onChange: setPaymentValue,
                value: payment.comment,
            })}
        </>
    );
};

export default PaymentFields;
